export default "__VITE_ASSET__Z0rW$9bg__"